// ✅ FILE: src/components/corporate-governance.js

import React from 'react';
import "./terms-conditions.css";
import './corporate-governance.css'; 

const CorporateGovernance = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Corporate Governance</h1>
      </header>

      <section className="tc-content mb-3">

        <h2>1. PREAMBLE:</h2>
        <p>
          DATTA FINANCE AND TRADING PRIVATE LIMITED (“Company”) believes that sound corporate governance practices are critical for the functioning of the Company and to create a trustworthy, transparent, moral and ethical, both internally and externally environment. The Company ensures good governance through the implementation of effective policies and procedures, which is mandated and regularly reviewed by the Board of Directors of the Company (“Board”) or by the Committees duly constituted by the Board, as the case may be.
        </p>

             <p> The Reserve Bank of India (“RBI”) vide Master Direction – Reserve Bank of India (Non-Banking Financial Company – Scale Based Regulation) Directions, 2023 (“RBI Master Directions”) as amended from time to time provides that all NBFCs should frame internal guidelines on corporate governance with the approval of the Board and publish the same on the Company's website for the information of various stakeholders. Accordingly, the Company has framed this policy on Corporate Governance (‘the Policy’).</p>

        <h2>2. PURPOSE:</h2>
        <p>The purpose of establishing this policy is to enable the adoption of best practices and greater transparency in the operations of the Company. In view of the RBI Master Directions, the Company has set out the following set of guidelines / corporate governance practices to create value for stakeholders such as the shareholders, employees, customers etc. The affairs of the Company shall be conducted with integrity, fairness, accountability, and transparency. All commitments in its dealings with stakeholders and regulatory authorities shall be met as set forth below. </p>


        <h2>3. DEFINITIONS:</h2>

       <ol className="definition-list">
        <li className="definition-item">
          “Applicable Laws” means the rules, regulations, directions, and
          guidelines applicable on the Company, including the RBI Master
          Directions applicable to the Company, the Companies Act,
          rules/regulations issued thereunder, as amended from time to time.
        </li>
        <li className="definition-item">“Board” means Board of Directors of the Company.</li>
        <li className="definition-item">
          “Committee” means the committee duly constituted by the Board, either
          as per Applicable Laws or otherwise, to:
          <ol className="subpoints">
            <li>perform the functions and responsibilities as per Applicable Laws,</li>
            <li>
              perform the functions and responsibilities delegated by the Board
              for effective management and control of business operations of the Company from time to time,
            </li>
            <li>to advise and/or make recommendations to the Board or key stakeholders.</li>
          </ol>

          
            <li className="definition-item">“Senior Management” means personnel of the Company who are members of its core management team excluding Board of Directors comprising all members of management one level below the executive directors, including the functional heads.</li>
        </li>
      </ol>

      <h2>4. INTERNAL GUIDELINES ON CORPORATE GOVERNANCE:</h2>

      <div>

        <h5><b>A. BOARD OF DIRECTORS:</b></h5>
  <p>
    <strong>Constitution:</strong> The Board of Director (‘Board’) shall consist of minimum two (02) directors. The Board shall have an optimum combination of executive and non-executive directors in line with the applicable laws and Articles of Association of the Company, as amended from time to time. All the directors shall make the necessary annual disclosures regarding their concern or interest in any company or bodies corporate, firms, or other association of individuals including shareholding, directorships and Committee positions and shall intimate changes therein as and when they take place.
  </p>

  <p>
    <strong>Roles & Responsibilities:</strong> Each member of the Board shall adhere to the following so as to support the existence of a good Corporate Governance environment:
  </p>

  <p>Shall attend the meetings of Board and/or Committees (as required) regularly and participate in the deliberations and discussions effectively.</p>

  <p>Shall review the agenda papers, notes and minutes of the Board and/or Committee meetings and enquire about the status update on any matter raised in previous meetings.</p>

  <p>Review the minutes of the proceedings of the Committees to evaluate the functioning of the respective Committees and adherence to their respective policy.</p>

  <p>Shall review and approve key policies.</p>

  <p>Shall ensure confidentiality of the company agenda papers, notes and minutes.</p>

  <p>Shall ensure that employees are given adequate autonomy within a well-defined and controlled operational framework to discharge their responsibilities and perform their duties in a disciplined manner with utmost integrity and through good conduct.</p>

  <p>Shall review the Compliance Certificate at every quarterly Board Meeting, which provides confirmation that all the Applicable Laws have been complied with as received from the Management.</p>

   <p><strong>Meetings of the Board:</strong> At least four meetings of Board shall be held in a year. The maximum time gap between any two meetings shall not be more than one hundred and twenty days (120 days) or as extended by regulator under Applicable Laws from time to time. The meetings of the Board can be convened either in person or through audio-video means as permitted under Applicable Laws.</p>

   <p><strong>Chairperson of the Meeting:</strong> The Chairperson of the Board and Committees shall conduct their respective meetings. If no such Chairman is elected or if the Chairman is unable to attend the Meeting, the Directors/members present at the Meeting shall elect one of themselves to chair and conduct the Meeting.</p>

   <p><strong>Quorum:</strong> The quorum for the meeting of the Board shall be one-third of total strength of the Board or two directors, whichever is higher, and the participation of the directors by video conferencing or by other audio-visual means shall also be reckoned for the purpose of quorum. The Quorum shall be present not only at the time of commencement of the Meeting but also while transacting business. The Interested Director may participate in the meeting after disclosing his / her interest pursuant to Section 184 of Companies Act, 2013 and may also be counted towards quorum for such meeting.</p>

    <h5><b>B. CONSTITUTION OF VARIOUS COMMITTEES:</b></h5>
  <p>To have close supervision on areas/activities that are critical from compliance or business perspective, expedite decision making, operational convenience and to ensure accountability, transparency and fairness, the Board has implemented an appropriate structure in the form of various Committees with defined terms of reference / scope and delegated requisite powers to respective Committees.</p>

  <p>Accordingly, the various Board Committees constituted under the relevant applicable laws are mentioned below -</p>

  <ol>
    <li>Audit Committee (ACM)</li>
    <li> Nomination and Remuneration Committee (NRC)</li>
    <li> Asset Liability Management Committee (ALMC)</li>
    <li> Risk Management Committee (RMC)</li>
    <li> Corporate Social Responsibility Committee (CSRC)</li>
    <li> IT Strategy Committee (ITSC)</li>
    <li> Stakeholders Relationship Committee (SRC)</li>
    <li> Loan, Investment and Borrowing Committee (LIBC)</li>
    <li> Securities Allotment Committee (SAC)</li>

  </ol>

 <h5><b>C. APPOINTMENT OF CHIEF COMPLIANCE OFFICER (CCO), CHIEF RISK OFFICER ("CR"O) AND HEAD OF INTERNAL AUDIT ("HIA"):</b></h5>
  <p>
    <strong>Chief Risk Officer ("CRO"): </strong> The Board has approved the policy on appointment of CRO as per the guidelines prescribed in Para 95 of the RBI Master Directions dated October 19, 2023, as amended from time to time. Further, the appointment of CRO shall be as recommended by the NRC and RMC and approved by the Board.
  </p>

    <p>
    <strong>Chief Compliance Officer ("CCO"): </strong> The Board has approved the policy on appointment of CCO as per the Circular RBI/2022-23/24 Ref.No.DoS.CO.PPG./SEC.01/11.01.005/2022-23 dated April 11, 2022. Further, the appointment of the CCO shall be recommended by the NRC and approved by the Board.
  </p>

  <p>
    <strong>Head of Internal Audit ("HIA"): </strong> The Board has approved the policy on Risk Based Internal Audit that establishes the authority, stature, independence, resources, objectivity, and position of the Internal Audit (IA) Department within the organization. The HIA shall be appointed based on the guidelines prescribed in the RBI Circular RBI/2020-21/88 Ref.No.DoS.CO.PPG./SEC.05/11.01.005/2020-21 dated February 03, 2021 and shall be recommended by NRC and ACM and approved by the Board.
  </p>
 
 <h5><b>D. FIT AND PROPER CRITERIA:</b></h5>
  <p>
    Pursuant to RBI Master Directions, a Board approved policy on ‘Fit and Proper Criteria for Directors’ (“the Policy”) is already in place. The Company shall obtain necessary disclosures, undertaking and declaration from the Directors at the time of appointment and on a continuing basis. The Company shall also furnish to the RBI a quarterly statement on change of directors, and a certificate from the Managing Director that fit and proper criteria in selection of the directors has been followed within 15 days of the close of the respective quarter. The statement for the quarter ending March 31 shall be certified by the auditors.
  </p>

  <h5><b>E. DISCLOSURE & TRANSPARENCY:</b></h5>
  <p>
    The Company shall comply with all the disclosure requirements in the financial statements as mandated under the applicable laws.
  </p>

   <h5><b>F. KEY MANAGERIAL PERSONNEL:</b></h5>
  <p>
    Except for directorship in a subsidiary, Key Managerial Personnel of the company will not hold any office (including directorships) in any other NBFC-ML or NBFC-UL.
  </p>

  <h5><b>G. INDEPENDENT DIRECTOR:</b></h5>
  <p>
    Within the permissible limits in terms of Companies Act, 2013, an independent director of the company shall not be on the Board of more than three NBFCs (NBFCs-ML or NBFCs-UL) at the same time. The Board shall ensure there is no conflict arising out of their independent directors being on the Board of another NBFC at the same time. There shall be no restriction to directorship on the Boards of NBFCs BL, subject to provisions of Companies Act, 2013.
  </p>

  <h5><b>H. COMPENSATION OF KEY MANAGERIAL PERSONNEL (KMP) AND SENIOR MANAGEMENT:</b></h5>
  <p>
    The Compensation of Key Managerial Personnel (KMP) and Senior Management shall be guided by the Compensation Policy of the Company.
  </p>
</div>

<h2>REVIEW OF THE POLICY:</h2>

<p>The Policy shall be amended or modified with approval of the Board. The Policy shall be reviewed by the Board on an annual basis. Consequent upon any amendments in Applicable Laws or any change in the position of the Company, necessary changes in this Policy shall be incorporated and approved by the Board.</p>

<p>Notwithstanding anything contained in this Policy, in case of any contradiction of the provision of this Policy with any existing legislation, rules, regulations, laws or modification thereof or enactment of a new applicable law, the provisions under such law, legislation, rules, regulation or enactment shall prevail over this Policy.</p>
        
      </section>
    </div>
  );
};

export default CorporateGovernance;
